import { ClassSummaryPage } from './ClassSummaryPage';
export default ClassSummaryPage;
